<template>
    <v-chip-group>
        <v-chip v-for="m in modules" small :dark="dark" :color="m.color" :key="m.value">
            {{ m.text }}
        </v-chip>
    </v-chip-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import OrderBy from 'lodash/orderBy';
export default {
    name: 'label-modules',
    data: () => ({}),
    created() {},
    mounted() {},
    props: {
        value: {},
        color: {
            default: null,
        },
        dark: {
            default: true,
        },
    },
    watch: {},
    computed: {
        modules() {
            if (this.value) {
                return OrderBy(
                    this.value.map((m) => {
                        return {
                            text: m,
                            value: m,
                            color: this.moduleColor(m),
                        };
                    }),
                    ['value'],
                    ['asc'],
                );
            }
            return [];
        },
    },
    methods: {
        moduleColor(role) {
            if (this.color) {
                return this.color;
            }

            return 'light-blue darken-2';
        },
    },
};
</script>
